/** Grunderna för språk och länder – ren data, ingen React eller i18next. */

export type Lang = "sv" | "en" | "es";
export const LANGS: Lang[] = ["sv", "en", "es"];
export const DEFAULT_LANG: Lang = "sv";

/** Vilka länder man kan sälja i. Land väljs per annons. */
export type SellCountry = "SE" | "ES";
export const SELL_COUNTRIES: SellCountry[] = ["SE", "ES"];
export const DEFAULT_COUNTRY: SellCountry = "SE";

/** Valuta per säljland. */
export const COUNTRY_CURRENCY: Record<SellCountry, string> = { SE: "SEK", ES: "EUR" };

export function isLang(v: unknown): v is Lang {
  return v === "sv" || v === "en" || v === "es";
}

export function isSellCountry(v: unknown): v is SellCountry {
  return v === "SE" || v === "ES";
}

/** Normaliserar webbläsarens språk till ett av våra (sv/en/es, annars sv). */
export function langFromBrowserLocale(locale: string | null | undefined): Lang {
  const l = (locale ?? "").toLowerCase();
  if (l.startsWith("sv")) return "sv";
  if (l.startsWith("es")) return "es";
  if (l.startsWith("en")) return "en";
  return DEFAULT_LANG;
}

export const LANG_COOKIE = "sellavo-lang";
export const COUNTRY_COOKIE = "sellavo-country";

/** BCP-tagg för HTML-lang och og:locale. */
export function htmlLang(lang: Lang): string {
  return lang === "sv" ? "sv-SE" : lang === "en" ? "en-GB" : "es-ES";
}

/** og:locale (med understreck, som Facebook vill ha det). */
export function ogLocale(lang: Lang): string {
  return lang === "sv" ? "sv_SE" : lang === "en" ? "en_GB" : "es_ES";
}

/** Läser en kaka i webbläsaren (aldrig vid serverrendering). */
export function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return m ? decodeURIComponent(m[1]) : null;
}

/** Sätter en kaka i webbläsaren (1 år). */
export function writeCookie(name: string, value: string) {
  if (typeof document === "undefined") return;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=31536000; samesite=lax`;
}
